<template>
  <div class="quantity__row">
    <div class="quantity-title">
      <p class="title">{{ option.label }}</p>
      <p class="subtitle">{{ option.description }}</p>
    </div>
    <VQuantity
      class="base-quantity"
      id="adult"
      v-model="inputValue"
      :minValue="0"
      :maxValue="12"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { Direction, PassengerType } from "@/models/Enums";
import { usePassengerStore } from "@/store/passengerStore";
import { VQuantity } from "v-ferry-components";

type PassengerOption = {
  label: string;
  description: string;
  passengerType: PassengerType;
  resourceCode: string;
  resourceType: string;
  type: string;
};

interface Props {
  direction: Direction;
  option: PassengerOption;
}

const props = defineProps<Props>();

const { getPassengers, setPassenger } = usePassengerStore();

const passengerCount = computed(() => {
  const passengers = getPassengers(props.direction);
  return passengers.filter(
    (p) => p.passengerType === props.option.passengerType
  ).length;
});

const inputValue = computed({
  get(): number {
    return passengerCount.value;
  },
  set(number: number) {
    setPassenger(props.direction, {
      passengerType: props.option.passengerType,
      amount: number,
    });
  },
});
</script>

<style lang="scss" scoped>
.quantity {
  padding: 0px 10px;
  overflow-y: auto;
  @include flex(column);

  &__row {
    @include flex(row, space-between);
    width: 100%;
    position: relative;
    padding: 15px 0;

    &::before {
      width: 100%;
      position: absolute;
      content: "";
      border-bottom: 1px solid var(--c-light-grey);
      top: 0;
    }

    .quantity-title {
      @include flex(column, center);
      max-width: 40%;
      p {
        margin: 0;
      }
      .title {
        font-weight: bold;
        font-size: 0.875rem;
        color: var(--c-pink);
      }
      .subtitle {
        font-style: italic;
        font-size: 0.75rem;
        color: var(--c-grey);
        white-space: break-spaces;
      }
    }
    .base-quantity {
      max-width: 120px;
    }
  }
}
</style>
